import React, { useContext, useRef, useState } from 'react';
import axiosConfig from '../../../../utils/axiosConfig';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import './NewsfeedForm.css';

import { Formik, Form, Field } from 'formik';
import { makeStyles } from "@material-ui/core/styles";
import { fieldToTextField, TextField, TextFieldProps, Select, Switch } from 'formik-material-ui';
import {
    Box,
    Button,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    Paper,
    Typography,
    TextField as MuiTextField,
    ButtonGroup,
    Icon
} from '@material-ui/core';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'

import FileList from '../Attachments/FileList'

import { StateContext, DispatchContext } from '../../../../context/Provider';

const editorConfiguration = {
    toolbar: {
        items: [
            'heading', '|',
            'bold', 'italic',
            'link', 'bulletedList', 'numberedList', '|',
            'outdent', 'indent', '|',
            'blockQuote', 'insertTable', '|',
            'undo', 'redo'
        ],
        viewportTopOffset: 30,
        shouldNotGroupWhenFull: true
    },
    mediaEmbed: {
        previewsInData: true
    }
};

const useStyles = makeStyles((theme) => ({
    root: {
        "& .MuiFilledInput-root": {
            background: "rgb(0, 0, 0, 0.05)"
        }
    }
}));

const NewsfeedForm = (props) => {

    const classes = useStyles();
    const appDispatch = useContext(DispatchContext);
    const { globalDispatch, facultyDispatch } = appDispatch;

    const [announcement, setAnnouncement] = useState({
        description: ''
    });

    const handleSubmit = () => {
        console.log('submit!');
    }

    async function createAnnouncement(values, setSubmitting, resetForm) {
        const formData = new FormData()
        formData.append('classcode', props.classcode)
        formData.append('description', announcement.description)

        for (var i = 0; i < selectedAttachment.length; i++) {
            formData.append('attachments[]', selectedAttachment[i])
        }

        const res = await axiosConfig.post(`/announcements`, formData);

        if (res.data.status_code == 'ok') {
            globalDispatch({type: 'setSnackbarMsg', value: 'Announcement created successfully.'});
            globalDispatch({type: 'setIsOpenSnackbar', value: true});

            props.fetchAnnouncements();
            props.handleCloseForm();

        } else {
            console.log(res);
        }

        setSubmitting(false);

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);

    }

    const fileAttachment = useRef(null)
    const [selectedAttachment, setSelectedAttachment] = useState([])

    return (
        <>
            <Formik
                initialValues={announcement}
                validate={(values) => {
                    const errors = {};
                    return errors;
                }}
                onSubmit={(values, {setSubmitting, resetForm}) => {
                    setSubmitting(true);
                    createAnnouncement(values, setSubmitting, resetForm);
                }}
            >
                {({submitForm, isSubmitting, touched, errors}) => (
                    <Form>
                        <Box mb={1}>
                            {/* <Field
                                component={TextField}
                                className={classes.root}
                                id="filled-multiline-static"
                                label="Announce something to your class"
                                name="description"
                                multiline
                                rows={4}
                                fullWidth
                                variant="filled"
                            /> */}

                            <div className="App">
                                <CKEditor
                                    editor={ ClassicEditor }
                                    config={ editorConfiguration }
                                    data=""
                                    // data="<p>Announce something to your class!</p>"
                                    onReady={ editor => {
                                        // You can store the "editor" and use when it is needed.
                                        // console.log( 'Editor is ready to use!', editor );
                                    } }
                                    onChange={ ( event, editor ) => {
                                        const data = editor.getData();
                                        setAnnouncement({description: data});
                                    } }
                                />
                                <Paper elevation={1} style={{marginTop: '20px', padding: '20px'}}>
                                    { selectedAttachment.length > 0 && <FileList items={selectedAttachment}/> }
                                    <a href="#"
                                        style={{textDecoration: 'none'}}
                                        onClick={() => {
                                            fileAttachment.current.click()
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faPlusCircle}/> Add attachments
                                    </a>
                                    <input type="file"
                                        ref={fileAttachment}
                                        style={{display: 'none'}}
                                        onChange={(file) => {
                                            const input = file.target
                                            const selectedFiles = input.files

                                            if (selectedFiles.length > 0) {
                                                let attachments = [];
                                                for (var i = 0; i < selectedFiles.length; i++) {
                                                    attachments.push(selectedFiles[i])
                                                }

                                                setSelectedAttachment(attachments)
                                            }
                                        }}
                                        multiple
                                    />
                                </Paper>
                            </div>

                        </Box>

                        <Box pt={2}>
                            <Grid
                                justify="flex-end"
                                container
                                spacing={3}
                            >
                                <Grid item>
                                    <Button
                                        size="small"
                                        disabled={isSubmitting}
                                        onClick={props.handleCloseForm}
                                        style={{textTransform: 'none'}}
                                    >
                                        Cancel
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        size="small"
                                        disabled={isSubmitting}
                                        onClick={submitForm}
                                        style={{textTransform: 'none'}}
                                    >
                                        Post
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Form>
                )}
            </Formik>
        </>
    );
}

export default NewsfeedForm;